import { useFormat } from 'vivat';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: {
        text: 'text-center',
        cell: 'text-left',
      },
    },
    orderNumber: {
      name: 'เลขที่ใบส่งสินค้า',
      width: '12rem',
    },
    // contactName: {
    //   name:
    // },
    customerName: {
      name: 'ชื่อผู้รับ',
      width: '1fr',
    },
    contactTelephone: {
      name: 'เบอร์ติดต่อ',
      width: '0.8fr',
      filter: (val: any, row: any) => `${row.item?.address?.telephone || ''}`,
    },
    totalWeight: {
      name: 'น้ำหนัก',
      width: '5rem',
      class: {
        text: 'text-right',
        cell: 'text-center',
      },
      filter: (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    'packages.length': {
      name: 'รายการสินค้า',
      width: '6rem',
      class: {
        text: 'text-center',
        cell: 'text-center',
      },
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง',
      width: '8rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => useFormat.number(val).currency(),
    },
    _imagesControls: {
      name: 'รูปภาพการจัดส่ง',
      width: '15rem',
      class: {
        cell: 'text-center',
      },
    },
    _signatureControls: {
      name: 'ลายเซ็นต์',
      width: '5.6rem',
      class: 'text-center',
    },
    _statusControls: {
      name: 'สถานะการจัดส่ง',
      width: '13rem',
      class: {
        cell: 'text-center',
      },
    },
  },
};
